import { Chip, Divider, Popover, Stack, Typography } from "@mui/material";

const SearchHelpPopover = ({
  anchorEl,
  open,
  onClose,
  onInsertQuery,
  guide,
}) => {
  if (!guide) return null;

  const { title, subtitle, sections = [] } = guide;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          maxHeight: 420,
          overflowY: "auto",
          width: 380,
          p: 2,
        },
      }}
    >
      <Stack spacing={1.5}>
        {(title || subtitle) && (
          <Stack>
            {title && (
              <Typography variant={"subtitle2"} fontWeight={700}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant={"caption"} color={"text.secondary"}>
                {subtitle}
              </Typography>
            )}
          </Stack>
        )}

        {sections.map((section, idx) => (
          <Stack key={section.title ?? idx} spacing={0.75}>
            {idx > 0 && <Divider />}
            {section.title && (
              <Typography
                variant={"caption"}
                color={"text.secondary"}
                fontWeight={600}
              >
                {section.title}
              </Typography>
            )}
            {section.description && (
              <Typography variant={"caption"} color={"text.secondary"}>
                {section.description}
              </Typography>
            )}
            {section.items?.map(({ label, chip }) => (
              <Stack
                key={chip}
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Typography
                  variant={"body2"}
                  color={"text.secondary"}
                  sx={{ minWidth: 120 }}
                >
                  {label}
                </Typography>
                <Chip
                  label={chip}
                  size={"small"}
                  variant={"outlined"}
                  sx={{
                    cursor: "pointer",
                    fontFamily: "monospace",
                    fontSize: "0.7rem",
                  }}
                  onClick={() => onInsertQuery(chip)}
                />
              </Stack>
            ))}
          </Stack>
        ))}
      </Stack>
    </Popover>
  );
};

export default SearchHelpPopover;
